import React from 'react'
import classNames from 'classnames'
import { ArrowLeftIcon } from '@/atoms/Icons/ArrowLeftIcon'
import { TitleXS } from '@/atoms/Text'
import { useMomentStory } from '@/contexts/MomentStoryContext'
import { MomentStoryPlayerHeader } from '@/organisms/CollectibleSceneInfo/EngagementDetailOverlay/MomentStoryPlayerHeader'
import { MomentStoryPlayer } from '@/organisms/StoryPlayer'
import { PlayableStory } from '@/utils/StoryUtil'
import { useTranslate } from '@/utils/translate/translate-client'

interface MomentStoryPanelProps {
  isOpen: boolean
  onClose: () => void
  story?: PlayableStory
}

export const MomentStoryPanel: React.FC<MomentStoryPanelProps> = ({ onClose, isOpen }) => {
  const { t } = useTranslate('watch')

  const { story } = useMomentStory()

  const userName = story?.userName
  const projectName = story?.projectName ?? 'Angel Studios'

  if (!story) return null

  return (
    <div
      id="story-detail-overlay"
      className={classNames(
        'fixed top-[60px] md:top-0 md:absolute inset-0 bg-core-gray-950 p-4 transition-all duration-200 ease-out',
        {
          'translate-x-0': isOpen,
          'translate-x-full': !isOpen,
        },
        'scrollbar scrollbar-thumb-gray-800 scrollbar-track-core-gray-950',
      )}
    >
      <div className="flex cursor-pointer items-center gap-x-2 pb-4" onClick={onClose}>
        <ArrowLeftIcon size={24} />
        <TitleXS weight={'bold'}>{t('backToOwners', 'Back To Owners')}</TitleXS>
      </div>
      <div className="pb-4">
        <MomentStoryPlayerHeader userName={userName} story={story} projectName={projectName} />
      </div>
      <div className="max-h-72">
        <MomentStoryPlayer isOverlayMode story={story} />
      </div>
    </div>
  )
}
